
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 49","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 .377h47.623V48H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M45.348 33.807l-12.541 12.54H14.869L2.276 33.755V15.87l12.54-12.594h18.15l12.382 12.382z"}}),_c('path',{attrs:{"d":"M29.842 36.438c0 1.931-1.213 2.5-2.71 1.271L12.275 25.5c-.664-.546-.657-1.42.02-1.953l14.794-11.662c1.52-1.198 2.754-.604 2.754 1.325v23.228z","fill":"#23a737"}}),_c('g',{attrs:{"transform":"translate(0 .623)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M45.348 33.184l-12.541 12.54H14.869L2.276 33.132V15.247l12.54-12.594h18.15l12.382 12.382v18.149zM33.918.377H13.864L0 14.294v19.789L13.917 48H33.76l13.863-13.863V14.082L33.918.377z","fill":"#23a737","mask":"url(#b)"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/object_forms/pn.svg